module.exports = __webpack_public_path__ + "img/HOME-6.8e538f33.png";